module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="referral-container">\n    <header>\n        <h2>' +
__e( header ) +
'</h2>\n        <h3>' +
__e( subheader ) +
'</h3>\n    </header>\n\n    ';
 if (loggedIn) { ;
__p += '\n        <section class="tab-switcher">\n            <div class="tab-switcher__body">\n                <section class="tab-switcher__tabs">\n                    <span class="tab-switcher__tab active" data-tab="phone">Text Message</span>\n                    <span class="tab-switcher__tab" data-tab="email">Email</span>\n                </section>\n                <section class="tab-switcher__content_container">\n                    <div class="tab-switcher__content" data-content="phone">\n                        <textarea placeholder="Phone numbers (separate by comma)" data-campaign="' +
__e( campaign ) +
'_invite_' +
__e( date ) +
'' +
__e( uid ) +
'"></textarea>\n                    </div>\n                    <div class="tab-switcher__content" data-content="email" style="display: none">\n                        <textarea placeholder="Email addresses (separate by comma)" data-campaign="' +
__e( campaign ) +
'_invite_' +
__e( date ) +
'' +
__e( uid ) +
'"></textarea>\n                    </div>\n                </section>\n            </div>\n            <section class="tab-switcher__footer">\n                <button class="btn btn-primary btn-large js-submit">\n                    <span>Send Invites</span>\n                    <span style="display: none">' +
((__t = ( $.svgIcon('approve') )) == null ? '' : __t) +
' Invites sent!</span>\n                </button>\n            </section>\n        </section>\n    ';
 } ;
__p += '\n\n    <section class="referral-options">\n\n        ';
 if (loggedIn) { ;
__p += '\n            <p class="referral-options__or">OR</p>\n            <p class="referral-options__share">Share on your network:</p>\n        ';
 } ;
__p += '\n\n        <div class="referral-options__buttons">\n            <div class="referral-options__icons">\n                ';
 ['fb', 'tw', 'li'].forEach(function(network) { ;
__p += '\n                    <a\n                        href="#"\n                        class="js-social-invite"\n                        data-url="' +
__e( url ) +
'"\n                        data-network="' +
__e( network ) +
'"\n                        data-medium="' +
__e( network ) +
'"\n                        data-campaign="' +
__e( campaign ) +
'_' +
__e( network ) +
'_share_';
 if (pid) { ;
__p +=
__e( pid ) +
'_';
 } ;
__p +=
__e( date ) +
'' +
__e( uid ) +
'"\n                    >\n                        ' +
((__t = ( $.svgIcon(network) )) == null ? '' : __t) +
'\n                    </a>\n                ';
 }) ;
__p += '\n            </div>\n            <div class="referral-options__copy">\n                <button\n                  class="btn btn-secondary btn-small js-copy"\n                  data-clipboard-text="' +
__e( url ) +
'?utm_source=ws-ref&utm_medium=directlink&utm_campaign=' +
__e( campaign ) +
'_link_share_';
 if (pid) { ;
__p +=
__e( pid ) +
'_';
 } ;
__p +=
__e( date ) +
'' +
__e( uid ) +
'">\n                    Copy Share Link\n                </button>\n            </div>\n        </div>\n    </section>\n\n    ';
 if (showFooter) { ;
__p += '\n        <footer class="referral-footer">\n            <a href="/">Continue to home</a>\n        </footer>\n    ';
 } ;
__p += '\n</div>\n';

}
return __p
}